import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import Link from "next/link";
import ModalLayout from "@layouts/modal";
import Icon from "@atoms/icon";
import PinIcon from '@icons/pin.svg';
import ChevronLeftIcon from '@icons/chevron-left.svg';
import CircleLoading from "../lotties/circle_loading";
import {scrollToOffsetTop} from "@helpers/helpers";

export default function CitiesModal({cities, show, setShow}) {
    const [search, setSearch] = useState([]);

    const handleSearch = (e) => {
        let pattern = String(e.target.value).toLowerCase();
        const updatedList = cities.filter(item => {
            return (
                item.label.toLowerCase().search(pattern) !== -1
            );
        });
        setSearch(updatedList)
    };

    useEffect(() => {
        setSearch([])
    }, [show]);


    return (
        <ModalLayout show={show} setShow={setShow} modalDialogClass="modal-sm" dialogBodyClassName="px-0">
            <Header className="d-flex align-items-center justify-content-center pb-16">
                <h2>انتخاب شهر</h2>
            </Header>

            {
                (cities.length) ?
                    <React.Fragment>
                        <div className="form-group px-24">
                            <input type="text" onChange={handleSearch} className="form-control" placeholder="جستجو..."/>
                        </div>

                        <Body className="">
                            <ul>
                                {
                                    (search && search.length) ?
                                        search.map((city, key) =>
                                            <Item key={key} label={city.label}/>
                                        )
                                        :
                                        (typeof cities !== "undefined") ?
                                            cities.map((city, key) =>
                                                <Item key={key} label={city.label}/>
                                            )
                                            : ''
                                }
                            </ul>
                        </Body>
                    </React.Fragment>
                    :
                    <div className="text-center py-48">
                        <CircleLoading width={64} height={64}/>
                    </div>
            }
        </ModalLayout>
    )
}

const Item = ({key, label}) => {
    const url = String(label).replace(' ', '-');
	
	const handleListClick = () => {
		scrollToOffsetTop(0, 0, false);
	};

    return (
		<li key={key} className="px-24" onClick={() => handleListClick()}>
			<Link href="/properties" as={"/املاک-" + url} >
				<a className="d-flex align-items-center justify-content-between py-8">
						<span className="d-flex align-items-center">
							<Icon width={16} height={16}><PinIcon/></Icon>
							<span className="mr-16">{label}</span>
						</span>

					<Icon className="chevron-left"><ChevronLeftIcon/></Icon>
				</a>
			</Link>
        </li>
    )
};

// styles

const Header = styled.div`
    line-height: 0;
`;

const Body = styled.div`
    height: calc(100vh - 430px) !important;
    overflow: auto;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        height: calc(100vh - 320px) !important;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        height: calc(100vh - 250px) !important;
    }
    
    .icons {
        &.chevron-left {
            width: 6px;
        }
    }
    
    li {
        &:hover {
            background-color: ${props => props.theme.gray200};
        }
    }
`;